import { render, staticRenderFns } from "./InputVcDemo.vue?vue&type=template&id=58daa298&scoped=true&"
import script from "./InputVcDemo.vue?vue&type=script&lang=js&"
export * from "./InputVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./InputVcDemo.vue?vue&type=style&index=0&id=58daa298&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58daa298",
  null
  
)

export default component.exports